import { Component } from '@angular/core';

@Component({
    selector: 'app-jobs-summary',
    templateUrl: './jobs-summary.component.html',
    styleUrls: ['./jobs-summary.component.scss'],
})
export class JobsSummaryComponent {}
